export default __webpack_public_path__ + "static/media/overpopulation.a26529ac.svg";